var _rect, _rect2, _path, _g, _rect3, _path2, _path3, _path4, _path5, _rect4, _g2, _rect5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrowserWalletDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 40.5,
    height: 40.5,
    rx: 8.25,
    fill: "#293249"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_304_15139)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 17,
    height: 17,
    rx: 6,
    fill: "#3375BB"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_304_15139)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_304_15139",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 17,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.843 2.99976H3.10449V19.7382H19.843V2.99976Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_304_15139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4737 19.7382C16.0959 19.7382 19.843 15.9912 19.843 11.369C19.843 6.74679 16.0959 2.99976 11.4737 2.99976C6.85153 2.99976 3.10449 6.74679 3.10449 11.369C3.10449 15.9912 6.85153 19.7382 11.4737 19.7382Z",
    fill: "#3375BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.533 6.66125C13.187 8.0426 15.0837 7.95741 15.6257 7.95741C15.5071 15.8135 14.6039 14.2556 11.533 16.4585C8.46215 14.2556 7.5646 15.8135 7.44604 7.95741C7.98233 7.95741 9.87903 8.0426 11.533 6.66125Z",
    stroke: "white",
    strokeWidth: 1.04615,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 22,
    width: 17,
    height: 17,
    rx: 6,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9393 30.9431C18.4082 29.8912 16.0762 26.938 13.8455 25.7213C12.4386 24.7707 10.981 24.8975 10.6769 25.3157C10.0305 26.2283 12.8315 27.0141 14.7073 27.914C14.3017 28.0914 13.9215 28.4083 13.706 28.8012C13.0089 28.0407 11.4753 27.3816 9.67558 27.914C8.45883 28.2688 7.45756 29.118 7.06465 30.3855C6.97593 30.3474 6.86186 30.3221 6.76046 30.3221C6.34221 30.3221 6 30.6643 6 31.0826C6 31.5008 6.34221 31.843 6.76046 31.843C6.83651 31.843 7.07732 31.7923 7.07732 31.7923L10.981 31.8177C9.42209 34.3019 8.18 34.6567 8.18 35.0877C8.18 35.5186 9.35872 35.4045 9.80232 35.2398C11.9316 34.4793 14.213 32.0838 14.6059 31.3994C16.2536 31.6149 17.6351 31.6276 17.9393 30.9431Z",
    fill: "url(#paint0_linear_304_15139)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7201 27.9138C14.8088 27.8758 14.7961 27.7491 14.7708 27.6477C14.7201 27.4195 13.7695 26.4816 12.8823 26.0634C11.6656 25.493 10.7784 25.5184 10.6516 25.7845C10.8924 26.2915 12.0458 26.7605 13.2372 27.2674C13.7315 27.4702 14.2511 27.6857 14.7201 27.9138Z",
    fill: "url(#paint1_linear_304_15139)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1737 33.0091C12.9328 32.9204 12.654 32.8317 12.3371 32.7556C12.6667 32.1599 12.7427 31.26 12.4259 30.7024C11.9823 29.9165 11.4246 29.4983 10.1191 29.4983C9.40936 29.4983 7.48285 29.7391 7.44482 31.3488C7.44482 31.5135 7.44482 31.6656 7.4575 31.8177H10.981C10.512 32.5655 10.0684 33.1232 9.67552 33.5414C10.1445 33.6555 10.5247 33.7569 10.8796 33.8583C11.2091 33.947 11.526 34.023 11.8428 34.1118C12.3245 33.7569 12.7808 33.3767 13.1737 33.0091Z",
    fill: "url(#paint2_linear_304_15139)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01397 31.6276C7.15338 32.8443 7.85048 33.326 9.27001 33.4654C10.6895 33.6048 11.5007 33.5161 12.578 33.6048C13.4779 33.6809 14.2891 34.1498 14.5806 33.985C14.8468 33.8456 14.6947 33.326 14.3398 32.9964C13.8708 32.5655 13.2244 32.274 12.0964 32.1599C12.3245 31.5389 12.2612 30.6644 11.9063 30.1954C11.3993 29.511 10.4614 29.2068 9.27001 29.3335C8.02792 29.4856 6.83652 30.1067 7.01397 31.6276Z",
    fill: "url(#paint3_linear_304_15139)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 3,
    width: 17,
    height: 36,
    rx: 6,
    fill: "#4C82FB",
    fillOpacity: 0.24
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_304_15139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5001 25.0833C33.0314 25.0833 35.0834 23.0313 35.0834 20.5C35.0834 17.9687 33.0314 15.9166 30.5001 15.9166C27.9688 15.9166 25.9167 17.9687 25.9167 20.5C25.9167 23.0313 27.9688 25.0833 30.5001 25.0833Z",
    stroke: "#4C82FB",
    strokeWidth: 0.825,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9167 20.5H35.0834",
    stroke: "#4C82FB",
    strokeWidth: 0.825,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5001 15.9166C31.6465 17.1717 32.298 18.8005 32.3334 20.5C32.298 22.1994 31.6465 23.8282 30.5001 25.0833C29.3537 23.8282 28.7022 22.1994 28.6667 20.5C28.7022 18.8005 29.3537 17.1717 30.5001 15.9166V15.9166Z",
    stroke: "#4C82FB",
    strokeWidth: 0.825,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 40.5,
    height: 40.5,
    rx: 8.25,
    stroke: "#1B2236",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_304_15139",
    x1: 9.54664,
    y1: 29.9616,
    x2: 17.8542,
    y2: 32.3175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8797FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAA8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_304_15139",
    x1: 16.147,
    y1: 30.1475,
    x2: 10.1527,
    y2: 24.1385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B22A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5156D8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_304_15139",
    x1: 13.3391,
    y1: 33.2263,
    x2: 7.58086,
    y2: 29.9157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B1E8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A6FFB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_304_15139",
    x1: 9.14535,
    y1: 30.6449,
    x2: 13.0375,
    y2: 35.5903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8898FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9839,
    stopColor: "#5F47F1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_304_15139"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 17,
    height: 17,
    rx: 6,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_304_15139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 16.7385,
    fill: "white",
    transform: "translate(3 2.99988)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_304_15139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(25 15)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowserWalletDark);
export default __webpack_public_path__ + "static/media/browser-wallet-dark.8a948cf354dcfcf78a7157db24c12a33.svg";
export { ForwardRef as ReactComponent };